import { createFileRoute } from "@tanstack/react-router";
import { ManifestScreen } from "./-settings/ManifestScreen";

export const Route = createFileRoute("/$workspace/$project/settings/manifest")({
  staticData: { title: "Manifest" },
  component: ManifestScreen,
});
